import { graphql } from "~/gql";

export const UPDATE_LIBRARY_EXCLUSIONS = graphql(/* GraphQL */ `
  mutation UpdateLibraryExclusions($data: [LibraryExclusionUpdate!]!) {
    updateLibraryExclusions(data: $data) {
      updatedExclusions {
        id
        text
        mandatory
        default
        organisationalUnits {
          name
          id
        }
        createdAt
      }
      matterIds
    }
  }
`);
